import { GlobalHealthSystem } from "../healthSystem/global-health-system";
import { HealthSystem } from "../healthSystem/health-system";
import { Patient } from "src/app/core/models/patient/patient";
import { Patient as OldPatient } from "src/app/core/model/patient";
import { Practitioner } from "../practitioner/practitioner";
import { AppointmentSlots } from "./appointmentSlots";
import { AppointmentType } from "./appointment-type";
import { PractitionerReferral } from "../practitioner/practitionerReferral";

export class Appointment {
  id: number;
  patientId: number;
  confirmedByPatient: boolean | null;
  comments: string;
  date: string;
  referralDate: string | null;
  appointmentDate: string | null;
  type: string;
  isActive: boolean;
  status: string;
  symptom: string;
  practitioner: Practitioner;
  healthSystemId: number;
  healthSystem: HealthSystem | GlobalHealthSystem;
  practitionerId: number;
  fromPractitionerId: number | null;
  diagnosisId: number | null;
  practitionerLocationId: number | null;
  referredByUserId: number | null;
  referralType: string;
  patient: Patient | OldPatient;  
  startTime: string;
  endTime: string;
  requestedSlot: string;
  // appointmentAvailableSlot: AppointmentSlots[] = [];
  appointmentAllottedSlots: AppointmentSlots[] = [];
  practitionerReferral: PractitionerReferral;
  _stateActive: boolean = true;
  startTimeUI: string;
  endTimeUI: string;
  duration: number;
  startDateTime: Date;
  endDateTime: Date;
  appointmentTypeId?: number;
  appointmentType?: AppointmentType;
  isVirtualVisit: boolean;
  isSymptomExistsEarlier: boolean;
  isTestDone: boolean;
  symptomBeginDate: string;
  symptomDetails: string;
  testResults: string;
  urgencyType: string;
  anotherPractiotioner: boolean;
  isWorkRelatedInjury: boolean;
  treatment: string;
  service: string;
  seenAnyDoctorEarlier: boolean;
}
